import { IFilter } from "../interfaces/IFilter";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/ebarimt/receipts", { offset, filter });
};

export const send = async () => {
  return httpRequest.get("/api/ebarimt/send");
};
